<template>
  <div
    class="data-table__body__row__cell"
    :class="'column-size__' + size"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DataCell',
  props: {
    size: {
      type: Number,
      default: 20
    }
  }
}
</script>

